/* istanbul ignore file */
import { datadogRum } from '@datadog/browser-rum'
import { reactPlugin } from '@datadog/browser-rum-react'
import 'intersection-observer'
import React from 'react'
import { createRoot } from 'react-dom/client'
import 'url-search-params-polyfill'
import { registerSW } from 'virtual:pwa-register'

import AppProviders from 'src/contexts'

import App from './App'
import './index.css'
import configureStore from './store/configureStore'

declare global {
  interface Window {
    APP_ENVIRONMENT?: 'PRODUCTION' | 'TESTING' | 'DEVELOPMENT' | 'TRAINING'
    DISABLE_TRACKING_FOR_STAFF: 'True' | 'False'
    HELP_CENTER_URL?: string
    SOURCE_VERSION?: string
    PREVIOUS_RELEASE_TAG?: string
    USER_ID_PREFIX?: string
    process: any
    SCHEDULER_ORDER_ITEMS_LIMIT?: number
    CUTOFF_TIME_GRACE_PERIOD_MINUTES?: number
    KNOWLEDGE_BASE_BUYER_URL?: string
    KNOWLEDGE_BASE_SELLER_URL?: string
    KNOWLEDGE_BASE_CENTRAL_URL?: string
    DATADOG_APPLICATION_ID?: string
    DATADOG_CLIENT_TOKEN?: string
    DATADOG_ENVIRONMENT?: string
    DATADOG_SERVICE_NAME?: string
    DATADOG_VERSION?: string
    DATADOG_SITE: string
  }
}

// process.env polyfill
if (!window.process) {
  window.process = { env: {} }
}

if (window.DATADOG_APPLICATION_ID && window.DATADOG_CLIENT_TOKEN) {
  datadogRum.init({
    applicationId: window.DATADOG_APPLICATION_ID,
    clientToken: window.DATADOG_CLIENT_TOKEN,
    site: window.DATADOG_SITE as any,
    service: window.DATADOG_SERVICE_NAME,
    env: window.DATADOG_ENVIRONMENT,
    version: window.DATADOG_VERSION,
    defaultPrivacyLevel: 'mask-user-input',
    trackLongTasks: false,
    trackResources: false,
    trackUserInteractions: false,
    trackViewsManually: false,
    plugins: [reactPlugin({ router: false })],
  })
}

// Create the store
const store = configureStore()

const container = document.getElementById('root')
const root = createRoot(container!)

root.render(
  <AppProviders store={store}>
    <App />
  </AppProviders>
)

registerSW({ immediate: true })
